import React from "react"

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              Terms and Conditions / Kushtet dhe Afatet e Përdorimit
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Last updated / Përditësuar së fundmi: 28/05/2025
            </p>
          </div>

          <div className="prose prose-gray dark:prose-invert max-w-none">
            {/* English Version */}
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 border-b border-gray-200 dark:border-gray-700 pb-2">
                English Version
              </h2>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  1. Acceptance of Terms
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  By accessing and using this website, you accept and agree to be bound by the terms 
                  and provision of this agreement. If you do not agree to abide by the above, please 
                  do not use this service.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  2. Use License
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Permission is granted to temporarily download one copy of the materials on our 
                  website for personal, non-commercial transitory viewing only. This is the grant 
                  of a license, not a transfer of title, and under this license you may not:
                </p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 ml-4">
                  <li>modify or copy the materials</li>
                  <li>use the materials for any commercial purpose or for any public display</li>
                  <li>attempt to reverse engineer any software contained on the website</li>
                  <li>remove any copyright or other proprietary notations from the materials</li>
                </ul>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  3. User Accounts
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  When you create an account with us, you must provide information that is accurate, 
                  complete, and current at all times. You are responsible for safeguarding the password 
                  and for all activities that occur under your account.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  4. Content Guidelines
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Users are prohibited from posting content that:
                </p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 ml-4">
                  <li>Is unlawful, harmful, threatening, abusive, or defamatory</li>
                  <li>Infringes on intellectual property rights</li>
                  <li>Contains spam, advertising, or promotional material</li>
                  <li>Is false, misleading, or deceptive</li>
                  <li>Violates any applicable laws or regulations</li>
                </ul>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  5. Privacy Policy
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Your privacy is important to us. We collect and use your personal information in 
                  accordance with our Privacy Policy. By using our service, you agree to the collection 
                  and use of information in accordance with our Privacy Policy.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  6. Disclaimer
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  The materials on our website are provided on an 'as is' basis. We make no warranties, 
                  expressed or implied, and hereby disclaim and negate all other warranties including 
                  without limitation, implied warranties or conditions of merchantability, fitness for 
                  a particular purpose, or non-infringement of intellectual property or other violation 
                  of rights.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  7. Limitations
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  In no event shall our company or its suppliers be liable for any damages (including, 
                  without limitation, damages for loss of data or profit, or due to business interruption) 
                  arising out of the use or inability to use the materials on our website, even if we 
                  or our authorized representative has been notified orally or in writing of the 
                  possibility of such damage.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  8. Accuracy of Materials
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  The materials appearing on our website could include technical, typographical, or 
                  photographic errors. We do not warrant that any of the materials on its website are 
                  accurate, complete, or current. We may make changes to the materials contained on its 
                  website at any time without notice.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  9. Links
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  We have not reviewed all of the sites linked to our website and are not responsible 
                  for the contents of any such linked site. The inclusion of any link does not imply 
                  endorsement by us of the site. Use of any such linked website is at the user's own risk.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  10. Modifications
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  We may revise these terms of service for its website at any time without notice. 
                  By using this website, you are agreeing to be bound by the then current version 
                  of these terms of service.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  11. Governing Law
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  These terms and conditions are governed by and construed in accordance with the laws 
                  and you irrevocably submit to the exclusive jurisdiction of the courts in that state 
                  or location.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  12. Contact Information
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  If you have any questions about these Terms and Conditions, please contact us at:
                </p>
                <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                  <p className="text-gray-700 dark:text-gray-300">
                    Email: support@merrvesh.com
                  </p>
                </div>
              </section>
            </div>

            {/* Albanian Version */}
            <div>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6 border-b border-gray-200 dark:border-gray-700 pb-2">
                Versioni Shqip
              </h2>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  1. Pranimi i Kushteve
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Duke hyrë dhe përdorur këtë faqe interneti, ju pranoni dhe jeni dakord të respektoni 
                  kushtet e këtij marrëveshjeje. Nëse nuk jeni dakord me ndonjërën prej tyre, ju lutemi 
                  mos e përdorni këtë shërbim.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  2. Licenca e Përdorimit
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Lejohet të shkarkoni përkohësisht një kopje të materialeve nga faqja jonë për përdorim 
                  personal, jokomercial dhe të përkohshëm për shikim. Kjo është një licencë, jo një 
                  transferim pronësie, dhe nën këtë licencë nuk lejohet të:
                </p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 ml-4">
                  <li>modifikoni ose kopjoni materialet</li>
                  <li>përdorni materialet për qëllime komerciale ose për ekspozim publik</li>
                  <li>përpiqeni të kundër-inxhinieroni ndonjë softuer të faqes</li>
                  <li>hiqni të drejtat e autorit ose shënimet pronësore nga materialet</li>
                </ul>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  3. Llogaritë e Përdoruesit
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Kur krijoni një llogari, duhet të jepni informacione të sakta, të plota dhe të 
                  përditësuara në çdo kohë. Ju jeni përgjegjës për ruajtjen e fjalëkalimit dhe për 
                  çdo veprim që ndodh përmes llogarisë suaj.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  4. Udhëzimet për Përmbajtjen
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Nuk lejohet postimi i përmbajtjeve që:
                </p>
                <ul className="list-disc list-inside text-gray-700 dark:text-gray-300 mb-4 ml-4">
                  <li>janë të paligjshme, të dëmshme, kërcënuese, fyese ose shpifëse</li>
                  <li>cenojnë të drejtat e pronësisë intelektuale</li>
                  <li>përmbajnë spam, reklama ose materiale promovuese</li>
                  <li>janë të pavërteta, mashtruese ose dezinformuese</li>
                  <li>shkelin ndonjë ligj apo rregullore në fuqi</li>
                </ul>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  5. Politika e Privatësisë
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Privatësia juaj është e rëndësishme për ne. Ne mbledhim dhe përdorim informacionin 
                  tuaj personal në përputhje me Politikën tonë të Privatësisë. Duke përdorur shërbimin 
                  tonë, ju jeni dakord me këtë mbledhje dhe përdorim.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  6. Mohim Përgjegjësie
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Materialet në këtë faqe jepen "siç janë". Ne nuk japim asnjë garanci, të shprehur 
                  ose të nënkuptuar, dhe mohojmë çdo përgjegjësi për garanci të tjera, përfshirë por 
                  pa u kufizuar në garancitë e tregtueshmërisë, përshtatshmërisë për një qëllim të 
                  caktuar ose mos-shkelje të të drejtave.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  7. Kufizime
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Në asnjë rast kompania jonë apo furnitorët tanë nuk janë përgjegjës për ndonjë dëm 
                  (duke përfshirë, por jo vetëm, humbjen e të dhënave ose të ardhurave, apo ndërprerjen 
                  e biznesit) që del nga përdorimi ose pamundësia për të përdorur materialet në këtë 
                  faqe, edhe nëse është njoftuar me shkrim apo gojërisht për mundësinë e një dëmi të tillë.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  8. Saktësia e Materialeve
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Materialet në këtë faqe mund të përmbajnë gabime teknike, shtypi ose fotografike. 
                  Ne nuk garantojmë që ndonjë nga materialet janë të sakta, të plota apo të përditësuara. 
                  Mund të bëjmë ndryshime në materialet e faqes në çdo kohë pa njoftim.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  9. Lidhjet
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Ne nuk kemi shqyrtuar të gjitha faqet që lidhen me faqen tonë dhe nuk jemi përgjegjës 
                  për përmbajtjen e tyre. Përfshirja e një lidhjeje nuk nënkupton miratim nga ana jonë. 
                  Përdorimi i këtyre faqeve të lidhura bëhet në rrezikun e përdoruesit.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  10. Ndryshime
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Mund të ndryshojmë këto kushte në çdo kohë pa njoftim. Duke përdorur faqen, ju 
                  pranoni të respektoni versionin aktual të kushteve të përdorimit.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  11. Ligji në Fuqi
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Këto kushte rregullohen dhe interpretohen në përputhje me ligjet në fuqi dhe ju 
                  pajtoheni të dorëzoheni në juridiksionin ekskluziv të gjykatave përkatëse.
                </p>
              </section>

              <section className="mb-8">
                <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  12. Kontakt
                </h3>
                <p className="text-gray-700 dark:text-gray-300 mb-4">
                  Për çdo pyetje lidhur me këto Kushte dhe Afate, mund të na kontaktoni në:
                </p>
                <div className="bg-gray-50 dark:bg-gray-700 p-4 rounded-lg">
                  <p className="text-gray-700 dark:text-gray-300">
                    Email: support@merrvesh.com
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsAndConditions 